import api from 'api';

export const loadCreativesGrid = api('POST /api/gallery-creatives/grid');
export const loadCreative = api('GET /api/gallery-creatives/:id');
export const loadCreativeDetails = api(
  'GET /api/gallery-creatives/:id/details'
);
export const loadCreativeActionsLog = api(
  'GET /api/gallery-creatives/:id/actions-log'
);
export const archiveCreative = api('POST /api/gallery-creatives/archive');
export const unarchiveCreative = api('POST /api/gallery-creatives/unarchive');

export const uploadFileChunk = api('POST /api/upload', {
  baseURL: `https://${process.env.REACT_APP_GALLERY_HOST}`,
});

export const createCreative = api('POST /api/gallery-creatives');
export const updateCreative = api('PUT /api/gallery-creatives/:id');
export const removeCreatives = api('POST /api/gallery-creatives/delete');

export const linkCreative = api('POST /api/gallery-creatives/link');

export const bulkUpload = api('POST /api/gallery/bulk');
export const bulkUploadStatus = api('GET /api/gallery/bulk');

export const exportCreatives = api('POST /api/gallery-creatives/export');
export const checkExportCreatives = api('GET /api/gallery-creatives/export');

export const batchShareCreatives = api('POST /api/gallery-creatives/share');
export const batchUnshareCreatives = api('POST /api/gallery-creatives/unshare');

export const moveCreative = api('POST /api/gallery-creatives/move');

export const loadCreativeDownloadUrl = api(
  'GET /api/gallery-creatives/:id/download-url'
);
export const loadCreativeCopyUrl = api(
  'GET /api/gallery-creatives/:id/view-url'
);
export const loadCreativeNameKey = api(
  'GET /api/gallery-creatives/:id/name-key'
);
export const swapCreativeWithOriginal = api(
  'POST /api/gallery-creatives/swap-with-original'
);
export const bulkEditCreatives = api('PUT /api/gallery-creatives/edit');
